module.exports = __webpack_public_path__ + "assets/img/track-top-bg-light.8c497446.png";